import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from "react";
import useHttp from "../../../hook/use-http";
import { API_URL_MAIN } from "../../../constants/driveglobalfilterinitalstates_bus";
import "./PdfPage.css";
import NoData from "./NoData";
import ChartLoader from "./ChartLoader";
import COmpBiDirTest from "./FaultSecondPageChartsBidirRender_Bus";

// export default function FaultThirdPart(props) {
const FaultThirdPart = forwardRef((props, ref) => {
  const { isLoading, error, sendReq: fetchData } = useHttp();
  let { title, template_id, show, soarting, gloablfilter, IND } = props;

  const [ECUData, setECUData] = useState({});
  const [TempDataAUX1, setTempDataAUX1] = useState([]);
  const [dataMainAUX1, setDataMainAUX1] = useState([]);
  const [toCalculateFaultAUX1, setToCalculateFaultAUX1] = useState(0);
  const [single_nameAUX1, setsingle_nameAUX1] = useState([]);
  const [LineContainerBodyBD, setCssLineCont] = useState({ height: "200px" });
  const [TempDataAUX2, setTempDataAUX2] = useState([]);
  const [dataMainAUX2, setDataMainAUX2] = useState([]);
  const [toCalculateFaultAUX2, setToCalculateFaultAUX2] = useState(0);
  const [single_nameAUX2, setsingle_nameAUX2] = useState([]);
  const [aux1_duration, setAux1_duration] = useState([]);
  const [aux2_duration, setAux2_duration] = useState([]);

  useEffect(() => {
    fetchData(
      {
        url: API_URL_MAIN + "pdf_bus/faultanalysis_bus",
        body: { filterdata: gloablfilter },
      },
      ecuFaultResponse
    );
  }, [gloablfilter]);

  useEffect(() => {
    fetchData(
      {
        url: API_URL_MAIN + "pdf_bus/vehicleLevalBusFault",
        body: { filterdata: gloablfilter, defaultNav: "Aux-1" },
      },
      responceBarData
    );
    fetchData(
      {
        url: API_URL_MAIN + "pdf_bus/vehicleLevalBusFault",
        body: { filterdata: gloablfilter, defaultNav: "Aux-2" },
      },
      responceBarData
    );
  }, [ECUData]);

  useImperativeHandle(ref, () => ({
    getDataForSlide: () => ({
      ECUData,
      TempDataAUX1,
      dataMainAUX1,
      toCalculateFaultAUX1,
      single_nameAUX1,
      LineContainerBodyBD,
      TempDataAUX2,
      dataMainAUX2,
      toCalculateFaultAUX2,
      single_nameAUX2,
      aux1_duration,
      aux2_duration,
    }),
  }));

  const ecuFaultResponse = (data) => {
    const ecuDict = {};
    data.forEach((item) => {
      const ecu = item.key.ECU;
      const vehicleCount = item.vehicle_count.value;
      ecuDict[ecu] = vehicleCount;
    });
    setECUData(ecuDict);
  };

  const responceBarData = (data) => {
    // setTempData(data)
    if (data.defaultNav === "Aux-1") {
      // setTempDataAUX1([]);
      // setDataMainAUX1([]);
      deno(data);
    } else if (data.defaultNav === "Aux-2") {
      // setTempDataAUX2([]);
      // setDataMainAUX2([]);
      deno(data);
    }
  };

  const deno = async (data) => {
    if (data.defaultNav !== null && data.defaultNav === "Aux-1") {
      //   if (ECUData.hasOwnProperty(defaultNav)) {
      await setTempDataAUX1(data.result);
      await setToCalculateFaultAUX1(ECUData[data.defaultNav]);
      //   }
    } else if (data.defaultNav !== null && data.defaultNav === "Aux-2") {
      await setTempDataAUX2(data.result);
      await setToCalculateFaultAUX2(ECUData[data.defaultNav]);
    }
  };

  useEffect(() => {
    if (toCalculateFaultAUX1 !== 0) {
      const data = TempDataAUX1;
      let dataArray = [];
      let maleAdd = 0;
      let femaleAdd = toCalculateFaultAUX1;
      data.forEach((obj1, index) => {
        maleAdd += obj1.duration.value;
      });
      setAux1_duration(maleAdd.toFixed(0));
      let single_name_array = [];
      data.forEach((obj1, index) => {
        let male = (obj1.duration.value / maleAdd) * 100;
        let female = (obj1.Total_vehicle_count.value / femaleAdd) * 100;
        dataArray.push({
          age: obj1.key.spnname.toUpperCase(),
          male: -male,
          female: female,
          orgLevalMale: obj1.duration.value.toFixed(0).toString(),
          orgLevalFemale: obj1.Total_vehicle_count.value.toString(),
          signal_nm: obj1.key.spnname,
          signal_desc: obj1.key.Description,
          signal_val: obj1.key.spnvalue.toString(),
        });
        single_name_array.push(obj1.key.spnname);
      });
      //   setsingle_nameBCS1(single_name_array);
      for (let i = 0; i < dataArray.length; i++) {
        let count = 0;
        for (let j = i + 1; j < dataArray.length; j++) {
          if (dataArray[i].age === dataArray[j].age) {
            dataArray[j].age = dataArray[j].age + "_" + dataArray[j].signal_val;
            count = 1;
          }
        }
        if (count) {
          dataArray[i].age = dataArray[i].age + "_" + dataArray[i].signal_val;
        }
      }
      dataArray.sort((a, b) => parseFloat(a.male) - parseFloat(b.male));
      setDataMainAUX1(dataArray);
    }

    if (toCalculateFaultAUX2 !== 0) {
      const data = TempDataAUX2;
      let dataArray = [];
      let maleAdd = 0;
      let femaleAdd = toCalculateFaultAUX2;
      data.forEach((obj1, index) => {
        maleAdd += obj1.duration.value;
      });
      setAux2_duration(maleAdd.toFixed(0));
      let single_name_array = [];
      data.forEach((obj1, index) => {
        let male = (obj1.duration.value / maleAdd) * 100;
        let female = (obj1.Total_vehicle_count.value / femaleAdd) * 100;
        dataArray.push({
          age: obj1.key.spnname.toUpperCase(),
          male: -male,
          female: female,
          orgLevalMale: obj1.duration.value.toFixed(0).toString(),
          orgLevalFemale: obj1.Total_vehicle_count.value.toString(),
          signal_nm: obj1.key.spnname,
          signal_desc: obj1.key.Description,
          signal_val: obj1.key.spnvalue.toString(),
        });
        single_name_array.push(obj1.key.spnname);
      });
      //   setsingle_nameBCS1(single_name_array);
      for (let i = 0; i < dataArray.length; i++) {
        let count = 0;
        for (let j = i + 1; j < dataArray.length; j++) {
          if (dataArray[i].age === dataArray[j].age) {
            dataArray[j].age = dataArray[j].age + "_" + dataArray[j].signal_val;
            count = 1;
          }
        }
        if (count) {
          dataArray[i].age = dataArray[i].age + "_" + dataArray[i].signal_val;
        }
      }
      dataArray.sort((a, b) => parseFloat(a.male) - parseFloat(b.male));
      setDataMainAUX2(dataArray);
    }
  }, [toCalculateFaultAUX1, toCalculateFaultAUX2]);

  return (
    <div className="faultfirstpart">
      <div className="row" style={{ justifyContent: "end" }}>
        <img
          src="../../../assets/img_Bus/Pdf_Page/Tatamotors.png"
          alt=""
          style={{ height: "80px", width: "250px" }}
        />
      </div>
      <div className="row mt-2">
        <div className="col-md-8">
          <span
            className="text-left"
            style={{
              fontSize: "20px",
              fontWeight: "bold",
              color: "#002060",
              paddingLeft: "30px",
            }}
          >
            Faults Observed in Field :{" "}
          </span>
          <span
            className="text-right"
            style={{ color: "#002060", fontSize: "12px" }}
          >
            {props.startdate} - {props.enddate}
          </span>
        </div>
      </div>

      <div className="row mt-3 ">
        <div className="col-md-1"></div>
        <div className="col-md-5">
          <div
            className="row"
            id="faultfirstparttitle_aux1"
            style={{ textAlign: "right" }}
          >
            <div className="col-md-4 text-start">
              <button className="btn" style={{ backgroundColor: "#d0d4d5" }}>
                Aux-1
              </button>
            </div>
            <div className="col-md-8 text-end">
              <dl style={{ marginBottom: "0rem", paddingRight: "3rem" }}>
                <dt className="red_bus"></dt>
                <dd>Time Duration (mins)</dd>
                <dt className="yellow_bus" style={{ marginLeft: "5px" }}></dt>
                <dd>Vehicle Count</dd>
              </dl>
            </div>
          </div>
          <div className="row pt-1">
            {/* {renderTabContent('BCS-1')} */}
            <div style={LineContainerBodyBD}>
              {isLoading ? (
                <ChartLoader />
              ) : dataMainAUX1.length > 0 ? (
                <div id="faultfirstpart_aux1">
                  <COmpBiDirTest
                    dataMain={dataMainAUX1}
                    id={"AUX1"}
                    gloablfilter={gloablfilter}
                    signal_name={single_nameAUX1}
                  />
                </div>
              ) : (
                <NoData />
              )}
            </div>
          </div>
        </div>

        <div className="col-md-5">
          <div
            className="row"
            id="faultfirstparttitle_aux2"
            style={{ textAlign: "right" }}
          >
            <div className="col-md-4 text-start">
              <button className="btn" style={{ backgroundColor: "#d0d4d5" }}>
                Aux-2
              </button>
            </div>
            <div className="col-md-8 text-end">
              <dl style={{ marginBottom: "0rem", paddingRight: "3rem" }}>
                <dt className="red_bus"></dt>
                <dd>Time Duration (mins)</dd>
                <dt className="yellow_bus" style={{ marginLeft: "5px" }}></dt>
                <dd>Vehicle Count</dd>
              </dl>
            </div>
          </div>
          <div className="row pt-1">
            <div style={LineContainerBodyBD}>
              {isLoading ? (
                <ChartLoader />
              ) : dataMainAUX2.length > 0 ? (
                <div id="faultfirstpart_aux2">
                  <COmpBiDirTest
                    dataMain={dataMainAUX2}
                    id={"AUX2"}
                    gloablfilter={gloablfilter}
                    signal_name={single_nameAUX2}
                  />
                </div>
              ) : (
                <NoData />
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="row bottomcontent pl-4" style={{ paddingTop: "455px" }}>
        <div className="col-md-3">
          <img
            src="../../../assets/img_Bus/Pdf_Page/footer.png"
            alt=""
            style={{ height: "70px", width: "200px" }}
          />
        </div>
        <div className="col-md-1"></div>
        <div className="col-md-4">
          <p
            style={{
              fontSize: "11px",
              paddingTop: "60px",
              paddingLeft: "10px",
            }}
          >
            Copyright, Confidential, Tata Motors Limited
          </p>
        </div>
      </div>
    </div>
  );
});

export default FaultThirdPart;
